import React from 'react';
import TextProcessor from "@/components/common/TextProcessor";
import clsx from "clsx";
import { type Block } from "@/sections/SectionRenderer";

interface EmpowerBannerData extends Block {
  title: string;
  description: string;
}

export const EmpowerBanner = ({ data }: { data: EmpowerBannerData }) => {
  const { id, title, description } = data;

  return (
    <section id={id} className="font-mulish py-16 px-4 md:px-8 lg:px-32 mx-auto">
      <div
        className={clsx("flex", description ? "flex-col md:flex-row justify-between items-start md:items-center" : "justify-center")}>
        <h2 className={clsx("text-4xl md:text-5xl lg:text-5xl leading-[1.2]", description && "mb-6 md:mb-0 md:w-1/2")}>
          <span className="inline-block bg-gradient-to-r from-[var(--color-gradient-start)] to-[var(--color-gradient-end)] bg-clip-text text-transparent [-webkit-text-fill-color:transparent] pt-[0.02em] pb-[0.18em] -mb-[0.12em]">
            <TextProcessor>
              {title}
            </TextProcessor>
          </span>
        </h2>
        {description &&
            <p className="text-lg md:text-xl text-auxiliary md:w-1/2 md:pl-8">
              {description}
            </p>
        }
      </div>
    </section>
  );
};
